// extracted by mini-css-extract-plugin
export default {"submitButton":"styles_submitButton__1okH9","button":"styles_button__Qwx3Z"};